{
  "title": "Personnalisez votre espace",
  "intro": "L’abonnement augmente certaines limites et débloque des options de personnalisation. Il n’accorde aucun avantage de progression : les probabilités, les prix et les récompenses restent identiques pour tous.",
  "offer": {
    "included": "Inclus dans l’abonnement"
  },
  "memberBadge": "Soutien Premium",
  "requiresPremium": "Inclus avec Premium",
  "free": "Gratuit",
  "perMonth": "par mois",
  "passTagline": "Le confort, pas la puissance.",
  "renewal": "Abonnement mensuel renouvelé automatiquement. Résiliable à tout moment pour la prochaine échéance.",
  "passComfort": "Jusqu’à 50 boosters par ouverture, 12 cartes en vitrine",
  "passIdentity": "Habillage et images personnalisés",
  "passSupport": "Vous contribuez au fonctionnement du site",
  "subscribe": "S’abonner pour {{price}}/mois",
  "signIn": "Se connecter pour s’abonner",
  "startFree": "Ou commencer gratuitement",
  "opening": "Ouverture de Stripe…",
  "loading": "Vérification de l’ouverture…",
  "soon": "Abonnements bientôt ouverts",
  "active": "Ton Premium est actif",
  "paidUntil": "Période réglée jusqu’au {{date}}.",
  "endsOn": "Renouvellement annulé. Accès jusqu’au {{date}}.",
  "manage": "Gérer mon abonnement et mes factures",
  "customize": "Personnaliser mon profil",
  "secure": "Paiement et facturation sécurisés par Stripe",
  "notReady": "Les abonnements sont en cours de configuration. Tu peux découvrir l’offre ; aucun paiement n’est possible pour le moment.",
  "verifyEmail": "Vérifie ton email depuis ton profil avant de t’abonner.",
  "testMode": "Environnement de test Stripe : aucun argent réel n’est débité.",
  "acceptBefore": "J’accepte les",
  "salesTerms": "conditions de vente",
  "acceptAfter": " et le renouvellement automatique à {{price}} par mois.",
  "paymentFailed": "La demande n’a pas abouti",
  "redirectInvalid": "L’adresse de paiement renvoyée n’est pas une page Stripe autorisée.",
  "confirming": "Nous attendons la confirmation du paiement par Stripe. Le retour sur cette page ne suffit pas à activer le Premium.",
  "confirmationSlow": "La confirmation prend plus de temps. Actualise ton état ou consulte la gestion de facturation avant de retenter un achat.",
  "checkoutCancelled": "Tu as quitté la page de paiement. Aucun Premium n’est activé sur la seule base de ce retour.",
  "suspended": "Un remboursement intégral, un litige ou une alerte de paiement suspend cet accès. Contacte l’administration pour vérifier le dossier.",
  "fairness": {
    "title": "Aucun raccourci vers la victoire.",
    "body": "L’abonnement n’offre ni Anima, ni booster, ni fragment, ni EXP supplémentaires. Les probabilités, les prix en Anima et les règles du marché restent identiques pour tous les joueurs."
  },
  "compare": {
    "eyebrow": "Comparatif",
    "title": "Gratuit ou Premium",
    "intro": "Collection, progression, marché, enchères et échanges restent accessibles sans abonnement.",
    "feature": "Fonction",
    "batch": "Boosters ouvrables en une fois",
    "friends": "Amis",
    "requests": "Demandes d’ami en attente",
    "showcase": "Cartes en vitrine",
    "listings": "Ventes simultanées",
    "auctions": "Enchères simultanées",
    "tradeCards": "Cartes par côté d’un échange",
    "tradeAnima": "Anima par échange",
    "palette": "Couleurs personnelles du site",
    "defaultPalette": "Thèmes Jour/Nuit",
    "personalPalette": "Palette privée Jour/Nuit",
    "progress": "Taux, gains et progression",
    "cosmetics": "Habillage du profil",
    "same": "Identiques",
    "earned": "Débloqué en jouant",
    "extra": "Jeu + habillage Premium",
    "note": "Les quotas quotidiens, commissions, places de vente et d’enchères et recharges gratuites restent identiques pour tous. Seuls les plafonds de cartes et d’Anima d’un échange sont plus élevés pour un joueur Premium."
  },
  "support": {
    "title": "Un abonnement pour soutenir ANIDEX",
    "body": "ANIDEX a besoin d’hébergement, d’une base de données, de stockage pour les images, d’emails et de services temps réel. Une collection et une communauté qui grandissent représentent des coûts réels. Le Premium contribue à les couvrir, sans inventer un montant ni promettre de financer à lui seul tout le site.",
    "promise": "Vous soutenez l’hébergement du site, sans acheter d’avantage dans le jeu."
  },
  "faq": {
    "title": "Questions fréquentes",
    "necessary": {
      "question": "Est-ce que je dois payer pour avancer ?",
      "answer": "Non. La collection, les boosters gratuits, les quêtes, la progression, le marché, les enchères et les échanges restent jouables sans abonnement. Premium n’ajoute aucun multiplicateur de gains."
    },
    "boosters": {
      "question": "Est-ce la même chose que le Booster Premium ?",
      "answer": "Non. Le Booster Premium du jeu s’obtient avec de l’Anima ou des récompenses de jeu. L’abonnement ANIDEX Premium n’en offre aucun et ne modifie aucun tirage. Les ouvertures de 50 utilisent uniquement ton stock et ton Anima."
    },
    "cancel": {
      "question": "Comment arrêter le renouvellement ?",
      "answer": "Ouvre Gérer mon abonnement et mes factures. Le portail Stripe permet d’annuler le renouvellement, de modifier le moyen de paiement et de consulter les factures. Une résiliation normale laisse l’accès jusqu’à la fin de la période déjà réglée."
    },
    "expiry": {
      "question": "Qu’est-ce qui se passe à l’expiration ?",
      "answer": "Aucune carte, aucun ami ni ressource de jeu n’est supprimé. Tu retrouves les limites gratuites. Les amis existants restent présents, mais tu dois repasser sous la limite avant d’en ajouter. Les six premières places de la vitrine restent affichées ; les autres sont conservées. L’habillage, les images et la palette Premium deviennent inactifs et peuvent revenir au réabonnement. Une offre d’échange déjà enregistrée conserve ses conditions ; une nouvelle offre ou contre-offre utilise les limites actuelles de chaque joueur."
    },
    "images": {
      "question": "Quelles images puis-je importer ?",
      "answer": "Des images statiques PNG, JPEG ou WebP dont tu as les droits, de 15 Mo maximum, 4 mégapixels et 4096 pixels par côté au plus. Tu peux personnaliser {{max}} portraits de cartes, en plus de ton avatar et de ta bannière. Les images ne sont pas transmises à l’acheteur ou au destinataire d’un échange."
    },
    "refund": {
      "question": "Et si je veux un remboursement ?",
      "answer": "Consulte les conditions de vente et contacte l’exploitant via les coordonnées des mentions légales. Les droits légaux applicables, dont le droit de rétractation lorsqu’il s’applique, restent respectés. Un remboursement ne se confond pas avec l’annulation du renouvellement."
    }
  },
  "readTerms": "Lire les conditions de vente",
  "tradeRules": "Premium : jusqu’à {{cards}} cartes et {{anima}} Anima proposés par côté d’un échange. Chaque joueur conserve son propre plafond. Les frais et les plafonds de ventes/enchères restent les mêmes.",
  "palette": {
    "title": "Mes couleurs du site",
    "settingsHint": "Une palette Premium privée pour tes thèmes Jour et Nuit.",
    "intro": "Ces couleurs ne concernent que ton compte. Elles sont conservées sur tes appareils connectés et ne modifient pas les cartes, les raretés ou les profils des autres joueurs.",
    "requiresPremium": "Personnalisation disponible avec un Premium actif.",
    "discover": "Découvrir Premium",
    "editingTheme": "Palette à modifier",
    "themes": {
      "light": "Jour",
      "dark": "Nuit"
    },
    "previewTheme": "Aperçu du site actuellement en {{theme}}.",
    "enable": "Utiliser mes couleurs pour le thème {{theme}}",
    "colorsLabel": "Couleurs de la palette",
    "colors": {
      "background": "Fond du site",
      "surface": "Panneaux",
      "text": "Texte principal",
      "mutedText": "Texte secondaire",
      "primary": "Boutons principaux",
      "accent": "Accents",
      "success": "Confirmations",
      "danger": "Avertissements"
    },
    "hexLabel": "{{color}}, valeur hexadécimale",
    "sample": "Exemple de ta palette",
    "sampleTitle": "Ton espace de collection",
    "sampleBody": "Un texte lisible et des couleurs qui te ressemblent.",
    "sampleButton": "Bouton d’exemple",
    "contrast": "Les libellés des boutons et liens sont ajustés pour rester lisibles. Fermer sans enregistrer restaure ta palette précédente.",
    "invalid": "Utilise des couleurs hexadécimales #RRGGBB.",
    "save": "Enregistrer mes couleurs",
    "saving": "Enregistrement…",
    "saved": "Couleurs personnelles enregistrées",
    "failed": "Les couleurs n’ont pas été enregistrées",
    "resetAll": "Restaurer les couleurs ANIDEX",
    "cancel": "Annuler"
  },
  "images": {
    "avatar": "Avatar personnalisé",
    "banner": "Bannière personnalisée",
    "card": "Portrait personnel de la carte",
    "hint": "PNG, JPEG ou WebP statique. 15 Mo, 4 mégapixels maximum. Jusqu’à {{max}} portraits de cartes, plus un avatar et une bannière.",
    "choose": "Choisir une image à importer",
    "preview": "Image personnelle actuelle",
    "discover": "Découvrir les images personnalisées avec Premium",
    "reset": "Revenir à l’image d’origine",
    "resetDone": "Image d’origine restaurée",
    "saved": "Image personnalisée enregistrée",
    "saving": "Enregistrement de l’image…",
    "failed": "L’image n’a pas été enregistrée",
    "tooLarge": "Cette image dépasse 15 Mo. Réduis sa taille avant de l’importer.",
    "rights": "Importe uniquement des images autorisées, sans informations sensibles. Les images sont accessibles par leur URL pendant un Premium actif, même si tu limites la visibilité de ton profil. Les règles de contenu et de modération restent applicables.",
    "stored": "Images enregistrées : {{count}}/{{max}} portraits de cartes",
    "storedHint": "Libère un emplacement en retirant une image, même si tu as vendu ou échangé la carte. Les images retirées ne sont plus disponibles dans les anciens partages.",
    "inactive": "Image inactive sans Premium",
    "noLongerOwned": "Carte absente de ta collection",
    "remove": "Retirer l’image"
  },
  "boosterHint": "Premium permet d’ouvrir jusqu’à 50 boosters en une fois, sans changer le prix ni les probabilités.",
  "profileLink": "Premium : confort, style et facturation",
  "tour": {
    "title": "Guide Premium",
    "progress": "Étape {{current}} sur {{total}}",
    "dotsLabel": "Progression du guide",
    "skip": "Passer le guide",
    "back": "Retour",
    "next": "Suivant",
    "finish": "Terminer",
    "reopen": "Revoir le guide",
    "steps": {
      "welcome": {
        "title": "Premium est actif",
        "body": "Ton abonnement est confirmé. Ce guide présente les fonctions qui viennent de s’activer et t’indique où les utiliser. Tu peux le rouvrir depuis cette page à tout moment.",
        "cta": "",
        "figure": ""
      },
      "boosters": {
        "title": "Ouvrir par lots",
        "body": "Ouvre jusqu’à 50 boosters déjà disponibles en une seule opération, au lieu de 10. Le stock et l’Anima dépensés restent strictement identiques.",
        "cta": "Ouvrir les boosters",
        "figure": "10 → 50 boosters par lot"
      },
      "identity": {
        "title": "Signature de soutien",
        "body": "Ton pseudo s’affiche en doré avec une couronne. Tu débloques aussi le titre Gardien d’ANIDEX, un cadre orbital et des effets d’avatar et de bannière.",
        "cta": "Habiller mon profil",
        "figure": "Pseudo doré, couronne et cadre orbital"
      },
      "images": {
        "title": "Images personnelles",
        "body": "Importe ton avatar, ta bannière et jusqu’à 20 portraits de cartes que tu possèdes. Seule l’image change : rareté, valeur et statistiques restent inchangées.",
        "cta": "Choisir mes images",
        "figure": "Avatar, bannière et 20 portraits"
      },
      "palette": {
        "title": "Couleurs personnelles",
        "body": "Choisis les fonds, textes, boutons et accents de l’interface, séparément en thème Jour et Nuit. Ta palette reste visible pour toi uniquement.",
        "cta": "Créer ma palette",
        "figure": "Palette privée Jour et Nuit"
      },
      "trades": {
        "title": "Échanges élargis",
        "body": "Propose jusqu’à 30 cartes et 50 000 Anima par côté d’un échange. Les plafonds de chaque joueur restent appliqués et les frais ne changent pas.",
        "cta": "Ouvrir les échanges",
        "figure": "15 → 30 cartes par côté"
      },
      "done": {
        "title": "Rien ne change dans le jeu",
        "body": "Aucune Anima, aucun booster ni gain supplémentaire. Les prix, les probabilités et les récompenses restent identiques pour tous les joueurs. Bonne collection.",
        "cta": "",
        "figure": "Mêmes prix, mêmes probabilités"
      }
    }
  },
  "tryout": {
    "eyebrow": "Démo",
    "title": "Essayez sans vous engager",
    "intro": "Cet aperçu est entièrement local : rien n’est enregistré ni envoyé. Testez les couleurs du site, l’habillage et vos propres images.",
    "username": "Collectionneur",
    "paletteLabel": "Couleurs du site",
    "paletteHint": "Ces couleurs ne s’appliquent qu’à cette page, pendant votre visite. Rien n’est enregistré.",
    "profileLabel": "Aperçu du profil",
    "free": "Gratuit",
    "premium": "Premium",
    "imagesLabel": "Vos images (locales)",
    "avatar": "Avatar",
    "banner": "Bannière",
    "card": "Portrait de carte",
    "choose": "Choisir une image",
    "change": "Changer",
    "remove": "Retirer",
    "cardTitle": "Carte personnalisée",
    "cardEmpty": "Choisissez une image de carte pour la prévisualiser ici.",
    "reset": "Tout effacer"
  }
}
